import Validator from '../validator';
import { phoneMustBeTenDigits } from '../validationUtils';

const AddUserValidator = new Validator([
  {
    field: 'firstName',
    method: 'isEmpty',
    validWhen: false,
    message: 'First name is required.',
  },
  {
    field: 'lastName',
    method: 'isEmpty',
    validWhen: false,
    message: 'Last name is required.',
  },
  {
    field: 'email',
    method: 'isEmpty',
    validWhen: false,
    message: 'Email address is required.',
  },
  {
    field: 'email',
    method: 'isEmail',
    validWhen: true,
    message: 'That is not a valid email address.',
  },
  {
    field: 'officePhone',
    method: 'isEmpty',
    validWhen: false,
    message: 'Phone is required.',
  },
  {
    field: 'officePhone',
    method: phoneMustBeTenDigits,
    validWhen: true,
    message: 'Phone must be ten digits.',
  },
  {
    field: 'securityLevel',
    method: 'isEmpty',
    validWhen: false,
    message: 'Security level is required.',
  },
  {
    field: 'agencyId',
    method: 'isEmpty',
    validWhen: false,
    message: 'Agency name is required.',
  },
]);

export default AddUserValidator;
